<template>
  <div class="writeApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    

    <div class="write" @click="jump(item.id,'share')" v-for="(item,i) in setNews">
      <div class="title">
        <h2>{{item.title}}</h2>
        <div class="cate">
          <span>{{item.read}}阅读</span>
          <span>{{item.createtime}}</span>
        </div>
      </div>

      <el-image class="right" :src="item.img" fit="cover">
        <div slot="placeholder" class="image-slot">
          <span class="dot"><i class="el-icon-loading"></i></span>
        </div>
      </el-image>
    </div>


    <div class="more" @click="more" v-if="page < sum && setNews.length > 0"><div>查看更多</div></div>
    <div class="more" v-if="page >= sum && setNews.length > 0"><div>无更多数据~</div></div>
    <div class="none" v-if="setNews.length <= 0 && sum == 0">
      <img src="~assets/images/none.png">
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: true,
        page:1,
        setNews:[],
        userData:[],
        sum:0,
        baseUrl:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        this.open()
      }
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getNews();
    },

    methods: {
      jump:function(index,url){
        this.$router.push({
          path:url,
         query:{
           id:index
         }
        })
      },
      open:function() {
        this.$alert('请先登录！', '警告', {
          confirmButtonText: '确定',
          showClose:false,
          callback: action => {
            var url = encodeURIComponent('http://user.laife.cn/main/login');
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf57bae009c299252&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
            return;
          }
        });
      },
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      more:function(){
        var total = this.sum;
        var page = this.page + 1;
        this.page = page;
        if(total >= this.page){
          this.getNews();
        }
      },
      getNews:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'wx/news/myShare',
          params:{
            page:that.page,
            userId:that.userData.id
          }
        }).then(function(response){
          var res = response.data;
          if (that.page == 1) {
            that.setNews = res.data.rs;
            that.sum = res.data.sum;
          } else {
            var contentlistTem = that.setNews;
            that.setNews = contentlistTem.concat(res.data.rs);
          }
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .writeApp{
    max-width:640px;
    background:#fff;
    margin:0 auto;
  }
  .writeApp .none{
    text-align:center;
    padding-top:50%;
  }
  .writeApp .none img{
    width:120px;
  }
  .writeApp .none p{
    color:#cdcdcd;
    font-size:14px;
  }
  .writeApp .none{
    text-align:center;
    padding-top:50%;
  }
  .writeApp .none img{
    width:120px;
  }
  .writeApp .none p{
    color:#cdcdcd;
    font-size:14px;
  }

  .writeApp .write{
    border-bottom:solid 1px #f1f2f3;
    width:92%;
    margin:0 auto;
    padding:15px 0;
  }
  .writeApp .write:after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0
  }
  .writeApp .write .title{
    float:left;
    width:65%;
    position:relative;
    height:90px;
  }
  .writeApp .write .title h2{
    font-size:15px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:3; 
    padding-right:8px;
  }
  .writeApp .write .title .cate{
    position:absolute;
    bottom:0;
    left:0;
    padding-right:8px;
  }
  .writeApp .write .title .cate span{
    font-size:13px;
    padding-right:15px;
    color:#a5a5a5
  }
  .writeApp .write .right{
    float:left;
    width:35%;
    height:90px;
    border-radius:5px
  }
  .writeApp .more div{
    display: block;
    width: 100%;
    text-align: center;
    font-size: 14px;
    padding:15px 0;
  }
</style>